import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { rem } from "./auth-service-tools172.js";
import "react";
import { closeOnEscape } from "./auth-service-tools183.js";
import { useProps } from "./auth-service-tools225.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { FloatingArrow } from "./auth-service-tools273.js";
import { FocusTrap } from "./auth-service-tools274.js";
import { OptionalPortal } from "./auth-service-tools275.js";
import { Transition } from "./auth-service-tools276.js";
import { usePopoverContext } from "./auth-service-tools266.js";
import classes from "./auth-service-tools270.js";
import { useFocusReturn } from "./auth-service-tools277.js";
import { useMergedRef } from "./auth-service-tools278.js";
const defaultProps = {};
const PopoverDropdown = factory((_props, ref) => {
  var _a, _b, _c, _d, _e;

  const props = useProps("PopoverDropdown", defaultProps, _props);
  const {
    className,
    style,
    vars,
    children,
    onKeyDownCapture,
    variant,
    classNames,
    styles,
    ...others
  } = props;
  const ctx = usePopoverContext();
  const returnFocus = useFocusReturn({
    opened: ctx.opened,
    shouldReturnFocus: ctx.returnFocus
  });
  const accessibleProps = ctx.withRoles ? {
    "aria-labelledby": ctx.getTargetId(),
    id: ctx.getDropdownId(),
    role: "dialog",
    tabIndex: -1
  } : {};
  const mergedRef = useMergedRef(ref, ctx.floating);

  if (ctx.disabled) {
    return null;
  }

  return /* @__PURE__ */jsxRuntimeExports.jsx(OptionalPortal, { ...ctx.portalProps,
    withinPortal: ctx.withinPortal,
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Transition, {
      mounted: ctx.opened,
      ...ctx.transitionProps,
      transition: ((_a = ctx.transitionProps) == null ? void 0 : _a.transition) || "fade",
      duration: (_c = (_b = ctx.transitionProps) == null ? void 0 : _b.duration) != null ? _c : 150,
      keepMounted: ctx.keepMounted,
      exitDuration: typeof ((_d = ctx.transitionProps) == null ? void 0 : _d.exitDuration) === "number" ? ctx.transitionProps.exitDuration : (_e = ctx.transitionProps) == null ? void 0 : _e.duration,
      children: transitionStyles => {
        var _a2, _b2;

        return /* @__PURE__ */jsxRuntimeExports.jsx(FocusTrap, {
          active: ctx.trapFocus && ctx.opened,
          innerRef: mergedRef,
          children: /* @__PURE__ */jsxRuntimeExports.jsxs(Box, { ...accessibleProps,
            ...others,
            variant,
            onKeyDownCapture: closeOnEscape(ctx.onClose, {
              active: ctx.closeOnEscape,
              onTrigger: returnFocus,
              onKeyDown: onKeyDownCapture
            }),
            "data-position": ctx.placement,
            "data-fixed": ctx.floatingStrategy === "fixed" || void 0,
            ...ctx.getStyles("dropdown", {
              className,
              props,
              classNames,
              styles,
              style: [{ ...transitionStyles,
                zIndex: ctx.zIndex,
                top: (_a2 = ctx.y) != null ? _a2 : 0,
                left: (_b2 = ctx.x) != null ? _b2 : 0,
                width: ctx.width === "target" ? void 0 : rem(ctx.width)
              }, style]
            }),
            children: [children, /* @__PURE__ */jsxRuntimeExports.jsx(FloatingArrow, {
              ref: ctx.arrowRef,
              arrowX: ctx.arrowX,
              arrowY: ctx.arrowY,
              visible: ctx.withArrow,
              position: ctx.placement,
              arrowSize: ctx.arrowSize,
              arrowRadius: ctx.arrowRadius,
              arrowOffset: ctx.arrowOffset,
              arrowPosition: ctx.arrowPosition,
              ...ctx.getStyles("arrow", {
                props,
                classNames,
                styles
              })
            })]
          })
        });
      }
    })
  });
});
PopoverDropdown.classes = classes;
PopoverDropdown.displayName = "@mantine/core/PopoverDropdown";
export { PopoverDropdown };